var exports = {
  "PT": "Markup.module__markup___ZldSTW",
  "z3": "Markup.module__bio___ZldSTW",
  "Z_": "Markup.module__mutedSpoilerContext___ZldSTW",
  "nf": "Markup.module__link___ZldSTW",
  "mG": "Markup.module__inline___ZldSTW",
  "tZ": "Markup.module__inlineFormat___ZldSTW",
  "Hy": "Markup.module__codeContainer___ZldSTW",
  "h": "Markup.module__blockquoteContainer___ZldSTW",
  "xE": "Markup.module__alert___ZldSTW",
  "CZ": "Markup.module__tableContainer___ZldSTW",
  "js": "Markup.module__latexCodeBlock___ZldSTW",
  "lB": "Markup.module__codeActions___ZldSTW",
  "vo": "Markup.module__codeActionsVisible___ZldSTW",
  "r": "Markup.module__blockquoteDivider___ZldSTW",
  "rs": "Markup.module__blockquoteContent___ZldSTW",
  "em": "Markup.module__blockquoteEmptyContent___ZldSTW",
  "tp": "Markup.module__table___ZldSTW",
  "qd": "Markup.module__tableHeader___ZldSTW",
  "xR": "Markup.module__tableCell___ZldSTW",
  "Vl": "Markup.module__alignLeft___ZldSTW",
  "Hu": "Markup.module__alignCenter___ZldSTW",
  "Wk": "Markup.module__alignRight___ZldSTW",
  "Qd": "Markup.module__alertIcon___ZldSTW",
  "Ro": "Markup.module__alertTitle___ZldSTW",
  "S9": "Markup.module__alertContent___ZldSTW",
  "FU": "Markup.module__alertNote___ZldSTW",
  "ap": "Markup.module__alertTip___ZldSTW",
  "nL": "Markup.module__alertImportant___ZldSTW",
  "vc": "Markup.module__alertWarning___ZldSTW",
  "SN": "Markup.module__alertCaution___ZldSTW",
  "lE": "Markup.module__mention___ZldSTW",
  "bG": "Markup.module__interactive___ZldSTW",
  "vE": "Markup.module__timestamp___ZldSTW",
  "CU": "Markup.module__spoilerWrapper___ZldSTW",
  "N5": "Markup.module__blockSpoilerWrapper___ZldSTW",
  "p6": "Markup.module__spoiler___ZldSTW",
  "mC": "Markup.module__blockSpoiler___ZldSTW",
  "ur": "Markup.module__spoilerContent___ZldSTW",
  "yI": "Markup.module__latexContent___ZldSTW",
  "Y4": "Markup.module__hljs___ZldSTW",
  "HQ": "Markup.module__ansiCode___ZldSTW",
  "So": "Markup.module__error___ZldSTW",
};

module.exports = exports;
